export const HEADER_TAB_UPLOAD = 'CREATE';
export const HEADER_TAB_UPDATE = 'UPDATE';
export const HEADER_TAB_DELETE = 'DELETE';

export const HISTORY_TAB_UPLOAD = 'HISTORY_TAB_UPLOAD';
export const HISTORY_TAB_DOWNLOAD = 'HISTORY_TAB_DOWNLOAD';
